import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, color, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
    <path
      className="pencil"
      d="M0,19v5H5L19.74,9.26l-5-5ZM23.61,5.39a1.33,1.33,0,0,0,0-1.88L20.49.39a1.33,1.33,0,0,0-1.88,0L16.17,2.83l5,5Z"
    />
  </svg>
))`
  position: relative;
  top: -1px;
  height: 1rem;

  .pencil {
    fill: ${({ disabled, color }) => color || (disabled ? lightGrey2Color : color)};
  }
`;
